import type { ListTeamsParams, ListTeamsResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { teamsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function listTeams(params: ListTeamsParams): Promise<ListTeamsResponse> {
  const searchParams = {
    direction: params.direction,
    itemsPerPage: params.itemsPerPage,
    page: params.page,
    search: params.search,
    sortBy: params.sortBy,
    teamType: params.teamType,
  };

  return apiClient.url("/teams").query(searchParams).get().json();
}

interface UseListTeamsParams extends Partial<ListTeamsParams> {
  enabled?: boolean;
}

export function useListTeams(params: UseListTeamsParams) {
  const { enabled = true, ...inputParams } = params;

  const queryParams: ListTeamsParams = {
    direction: inputParams.direction ?? "desc",
    itemsPerPage: inputParams.itemsPerPage ?? 10,
    page: inputParams.page ?? 1,
    search: inputParams.search,
    sortBy: inputParams.sortBy ?? "createdAt",
    teamType: inputParams.teamType ?? "all",
  };

  return useQuery({
    enabled,
    queryFn: () => listTeams(queryParams),
    queryKey: teamsKeys.list(queryParams),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
